export default __webpack_public_path__ + "cb48d26daadc84511a5ce80e90632abc.png";